import { render, staticRenderFns } from "./PurchaseFish.vue?vue&type=template&id=0cd974a6&scoped=true"
import script from "./PurchaseFish.vue?vue&type=script&setup=true&lang=ts"
export * from "./PurchaseFish.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./PurchaseFish.vue?vue&type=style&index=0&id=0cd974a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd974a6",
  null
  
)

export default component.exports